import { JSEncrypt } from 'jsencrypt';
import { GA } from '../../features/orp/helper/constants';
import { CD_CAPS, DRC_CAPS, NEW_HF, NEW_HOME_CONTENT, NEW_THEME, OPCO, SELECTED_LANGUAGE } from '../../FTTX/GlobalConstant';
import { fetchSessionData } from './storage';
import { getORPImgUrl } from '../../FTTX/utills';
import { LEAD_STATUS_ICONS, LEAD_STATUS_LIST } from '../../FTTX/GlobalConstant';
import { LANGUAGE_MAP } from '../constants/constant';

export function getDistance(lat1, lon1, lat2, lon2) {
  const R = 3958.8; // Radius of the earth in miles
  const dLat = deg2rad(lat2 - lat1);
  // deg2rad below
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2)
    ;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Distance in km
  // const roundedNumber = round(d);
  return d.toFixed(1);
}

export function deg2rad(deg) {
  return deg * (Math.PI / 180)
};

export function debounce(func, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}



export const filterCategories = (data, key, category) => {
  return data?.filter(ele => ele[key] === category)
}

export const filterByUniqueData = (categoryData, key) => {
  return categoryData?.filter((ele, index) => categoryData.findIndex(data => data?.[key]?.toLowerCase() === ele?.[key]?.toLowerCase()) === index)
}

export const changeImageSrcToCdn = (imgList = []) => {
  for (var i = 0; i < imgList.length; i++) {
    var newSrc = imgList[i].src.replace(/https?:\/\/[^/]+\/assets/gi, `https://cdn-webportal.airtelstream.net/website/${process.env.REACT_APP_COUNTRY}/assets`);
    imgList[i].src = newSrc;
  }
}

export const changePDFsrcToCdn = (pdfList) => {
  for (var i = 0; i < pdfList.length; i++) {
    var newSrc = pdfList[i].href.replace(/https?:\/\/[^/]+\/assets/gi, `https://cdn-webportal.airtelstream.net/website/${process.env.REACT_APP_COUNTRY}/assets`);
    pdfList[i].href = newSrc;
  }
}

export const generateEventPageName = (path) => {
  let url = path?.trim();
  let pathElements = url == '/' ? [] : url?.split('/');
  let lastIndex = pathElements?.length - 1;
  if (pathElements[lastIndex] === '') {
    lastIndex = lastIndex - 1;
  }
  let currentPage = pathElements[lastIndex]
  currentPage = currentPage && currentPage?.replaceAll('-', '_');
  currentPage = currentPage ? currentPage : 'homepage'
  return `cw_${currentPage}`.toLowerCase();
}

export const clearAirtelWorksData = () => {
  sessionStorage.removeItem('airtelWorks');
}

export const encrypt = (data) => {
  const PUBLIC_KEY = (process.env.REACT_APP_MODE === "UAT" ?
    process.env.REACT_APP_RSA_PUBLIC_KEY_UAT : process.env.REACT_APP_RSA_PUBLIC_KEY_PROD)
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(PUBLIC_KEY);
  return encrypt.encrypt(data);
}

export const generateMsisdn = (msisdn) => {
  return process.env.REACT_APP_X_COUNTRY?.toLowerCase() == GA
    ? "0" + msisdn
    : msisdn
}

let lastValidationTime = 0;
export function throttle(fn, delay) {
  return function (...args) {
    const now = Date.now();
    if (now - lastValidationTime >= delay) {
      lastValidationTime = now;
      fn.apply(this, args);
    }
  };
}


export const encryptRSA = (pin, publicKey) => {
  const encrypt = new JSEncrypt(publicKey);
  encrypt.setPublicKey(publicKey);
  return encrypt.encrypt(pin);
}

export function getDataFromUrlParams(key = "") {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get(key);
}

export const getOPCO = () => getDataFromUrlParams(OPCO) || fetchSessionData(OPCO) || process.env.REACT_APP_OPCO;

export const getOpcoRegion = () => {
  const opco = getOPCO();
  return opco === DRC_CAPS ? CD_CAPS : opco;
}

export const getIsNewTheme = () => {
  const themeFromUrl = getDataFromUrlParams(NEW_THEME);
  if (themeFromUrl === "false") {
    return false;
  }
  return themeFromUrl === "true" || fetchSessionData(NEW_THEME) === "true" || process.env.REACT_APP_NEW_THEME === "true";
}

export const getSelectedLanguage = () => {
  return sessionStorage.getItem(SELECTED_LANGUAGE) || LANGUAGE_MAP[process.env.REACT_APP_DEFAULT_LANGAUAGE];
};


export const isNewHeaderFooter = () => {
  const newHF = getDataFromUrlParams(NEW_HF);
  return getIsNewTheme() || newHF === "true" || fetchSessionData(NEW_HF) === "true";
}

export const isNewHomeContent = () => {
  const newHomeContent = getDataFromUrlParams(NEW_HOME_CONTENT);
  return getIsNewTheme() || newHomeContent === "true" || fetchSessionData(NEW_HOME_CONTENT) === "true";
}

export const getLeadStatusIcon = (status) => {
  let icon = '';
  switch (status) {
    case LEAD_STATUS_LIST.completed:
    case LEAD_STATUS_LIST.success:
    case LEAD_STATUS_LIST.created:
      icon = LEAD_STATUS_ICONS.GREEN_CHECKMARK;
      break;

    case LEAD_STATUS_LIST.inprogress:
      icon = LEAD_STATUS_ICONS.YELLOW_CHECKMARK;
      break;

    case LEAD_STATUS_LIST.not_started:
      icon = LEAD_STATUS_ICONS.GRAY_CHECKMARK;
      break;

    case LEAD_STATUS_LIST.cancelled:
    case LEAD_STATUS_LIST.failed:
      icon = LEAD_STATUS_ICONS.RED_CHECKMARK;
      break;

    default:
      icon = LEAD_STATUS_ICONS.GRAY_CHECKMARK;
  }
  return getORPImgUrl(icon, "icons");;
}

export const allowNewThemeRedirection = (isNewThemeRedirection = false) => {
  return isNewThemeRedirection && getIsNewTheme()
}
